export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyCOolVJCPxh1VCRJbPiqsNu_PIkpot1wP8",
    authDomain: "qservus-surv-qa.firebaseapp.com",
    projectId: "qservus-surv-qa",
    storageBucket: "qservus-surv-qa.appspot.com",
    messagingSenderId: "531627001352",
    appId: "1:531627001352:web:3c89f00554056dc409f3bd",
    measurementId: "G-YN860GSMN2"
  },
  awsBucket: {
    region: "ca-central-1",
    bucket_name: "qservus.qa",
    folder: "surv-qa/",
    domain: "https://s3.ca-central-1.amazonaws.com/qservus.qa",
    custom_domain: "https://dh4fyf9axoztv.cloudfront.net",
    identityPoolId: "ca-central-1:c81d1533-d03c-46f6-88e8-1e0afaf14fb4"
  },
  mongoAPI: 'http://127.0.0.1:8080/api/qss',
  sentryEnabled: true,
  sentryDsn: "https://b3b310163ab44938af0b8f709bb4936d@o329695.ingest.sentry.io/5973973",
  sentryEnvironment: "QA",
  sentryRelease: "qservus-survey@qa",
  enableFirebasePerformance: true,
  enableUpdatePreflight: true,
  enableWebVitalsTracking: true,
  webVitalsSampleRate: 1,
  qsApiUrl: 'https://qa.qservus.com/api/',  // QA
  qsApiQSSUrl: 'https://qa.qservus.com/api/qss/',
  qsToken: "Token e478ea3e806c566ad9055c3ca78b9807142931a6", // QA
  qsBaseUrl: 'https://qa.qservus.com',
  passCrypt: "9js!2d4^^%^009870^*jkvcT%74*AS(639.3$Fcma_sdXZfJ*",
  recaptcha: {
    siteKey: '6LeGJA8aAAAAAFSYK58GUN_Hj2g7YCkRGaE4JqSf', // QA
    // siteKey: '6LcpZ7AeAAAAAJvHck606vKCQPdKUmkRPhHOzTyE', // DEV
  },
  survPageURL: "https://surv-qa.qservus.com/",
  qservusGlobalAuth: {
    user: "dgarcia2@qservus.com",
    pass: "w$V^Ib&!k1X!EUV9$dfZhjI@"
  },
  defaultBanner: "https://cdn-qservus.redcalidad.com/img/banner_qs_blue.png",
  calendly: {
    dgarsil: "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjU1MzA2NjMyLCJqdGkiOiI0MWIxN2UwNS02ZGRiLTRiYmYtYTM0Ni1hYzA4MmYxZDc4MjYiLCJ1c2VyX3V1aWQiOiI5NTM5ZDVjYy05OWIzLTRkZDMtYTkzMS02ZmFhOGFjNmNlOGIifQ._2fzUkMKOmqpSQ_d1NUdjJpOHK1ic31HvqCO05A4vx8",
    hlobos: ""
  },
  google_api_key: "AIzaSyCOolVJCPxh1VCRJbPiqsNu_PIkpot1wP8",
  check_rut_api_key: "cD5dqhjq6P3DkJRl5ao4DJYgMeki5W6EbUBBrO0PbjZpXQ0d8VIRVbZBJkkLGewP",
};
